import { FC } from 'react';

export const NavItemSkeleton: FC<any> = ({ viewRef }) => {
  return (
    <div className="ml-2.5 mr-0 last:mr-2.5" ref={viewRef}>
      <div
        className="bg-surface-200-bg inline-block  rounded-500 skeleton"
        style={{ height: '110px', width: '110px' }}
      />
      <div className="mx-2">
        <div className="mt-200 bg-surface-200-bg w-full skeleton rounded-sm" style={{ height: '18px' }} />
        <div className="mt-200 placeholder:bg-surface-200-bg inline-block w-16 h-5 skeleton rounded-full" />
      </div>
    </div>
  );
};
